import React from 'react';
import UserProfile from '../Auth/UserProfile';
import logotipoFct from '../../fct/marca/farmaconsulting-logotipo.png';
import '../../estilos/gescomaux.css';

/**
 * Layout reducido para proveedores externos (Smartup): cabecera mínima, sin menú interno.
 * Quien mira está fuera de FCT, así que lleva la firma corporativa (cruz y logotipo), no el
 * isotipo de GescomAux (GCVSC-I001, R-08). Piel interna como el resto de la app.
 */
const ExternalLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="gc-externa">
    <header className="gc-externa__cabecera">
      <div className="gc-externa__marca">
        <img src={logotipoFct} alt="Farmaconsulting" />
      </div>
      <UserProfile />
    </header>
    <main className="gc-externa__principal">{children}</main>
  </div>
);

export default ExternalLayout;
